var React = require('react');

function Divider (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"1","fill":"#c6c3b9","width":"16","height":".2"},React.createElement("animate",{"attributeName":"x","attributeType":"XML","values":"1; 64; 1","begin":"0s","dur":"1.5s","repeatCount":"indefinite"})));
}

Divider.defaultProps = {"version":"1.1","className":"svg-divider","x":"0px","y":"0px","viewBox":"0 0 80 3","xmlSpace":"preserve"};

module.exports = Divider;

Divider.default = Divider;
